import { PaperClipIcon, StarIcon } from "@heroicons/react/24/solid";
import React, { FC, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonThird from "shared/Button/ButtonThird";
import { requestAPI } from "utils/api";


const CommentListing = ({
	className,
	_id,
	user_id,
	self_id,
	name,
	avatar,
	date,
	_comment,
	dataLoad
}: any) => {
	console.log(`${user_id} ${self_id} ${_comment}`)

	const [ isModify, setIsModify ] = useState <boolean> (false);
	const [ comment, setComment ] = useState <string> ("");

	useEffect (() => {
		setComment(_comment);
	}, [_comment]);

	const handleChange = async (value: string) => {
		
		setComment(value);
	};

	const handleModify = async () => {
		
		setIsModify(true);
	};

	const deleteRequest = async () => {
		
		console.log(comment);
		console.log(_id);
		
		const res: any = await requestAPI ('DELETE', `v1/comment/community/${_id}`, {});		
		
		setIsModify(false);	

		dataLoad();
	};

	const modifyRequest = async () => {
		
		console.log(comment);
		console.log(_id);
		
		const res: any = await requestAPI ('PUT', `v1/comment/community/${_id}`, {
			commentContents: comment
		});		
		
		setIsModify(false);	
	};

	return (
		<>
		{isModify === false
		?
			<div
				className={`nc-CommentListing flex space-x-4 ${className}`}
				data-nc-id="CommentListing"
			>
				<div className="pt-0.5">
					<Avatar
						sizeClass="h-10 w-10 text-lg"
						radius="rounded-full"
						userName={name}
						imgUrl={avatar}
					/>
				</div>
				<div className="flex-grow">
					<div className="flex justify-between space-x-3">
						<div className="flex flex-col">
							<div className="text-sm font-semibold">
								<span>{name}</span>
							</div>
							<span className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
								{date}
							</span>
						</div>
					</div>
					<span
						className="block mt-3 text-neutral-6000 dark:text-neutral-300 text-[1.0rem]"
						style={{ fontWeight: "500", color: "#282f33" }}
					>
						{comment}
					</span>
					<div className="flex justify-between">
						<div></div>
						<div className="mr-4">
							{(self_id === user_id)
								?
								<>
									<div className="!space-x-2">
										<ButtonThird
											className="!m-0 !pl-4 !pr-4 !pt-2 !pb-2"
											onClick={() => deleteRequest()}
										>
											삭제
										</ButtonThird>
										<ButtonPrimary
											className="!m-0 !pl-4 !pr-4 !pt-2 !pb-2"
											onClick={() => handleModify()}
										>
											수정
										</ButtonPrimary>
									</div>
								</>
								:
								<></>
							}
						</div>
					</div>
				</div>
			</div>
		:
			<div className="flex items-start space-x-4">
				<div className="min-w-0 flex-1">
					<form action="#">
						<div className="border-b border-gray-200 focus-within:border-indigo-600">
							<label htmlFor="comment" className="sr-only">
								댓글 수정
							</label>
							<textarea
								id="comment"
								name="comment"
								rows={3}
								placeholder="Add your comment..."
								className="!rounded-lg block w-full resize-none border-0 border-b border-transparent p-0 pb-2 text-gray-900 placeholder:text-gray-400 focus:border-indigo-600 focus:ring-0 sm:text-sm/6"
								value={comment}
								onChange={e => handleChange(e.target.value)}
							/>
						</div>
						<div className="flex justify-between pt-2">
							<div className="flex items-center space-x-5">
								<div className="flow-root">
									
								</div>
								<div className="flow-root">
									
								</div>
							</div>
							<div className="shrink-0">
								<button
									type="button"
									className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
									onClick={e => modifyRequest()}
								>
									전송
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		}
		</>
	);
};

export default CommentListing;
